var React = require('react');

function Ellipse (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"3","cy":"3","r":"3","fill":"white"}));
}

Ellipse.defaultProps = {"width":"6","height":"6","viewBox":"0 0 6 6","fill":"none"};

module.exports = Ellipse;

Ellipse.default = Ellipse;
